import { render } from "./JobTable.vue?vue&type=template&id=7ccd1f74&scoped=true"
import script from "./JobTable.vue?vue&type=script&lang=js"
export * from "./JobTable.vue?vue&type=script&lang=js"

import "./JobTable.vue?vue&type=style&index=0&id=7ccd1f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccd1f74"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTd,QPagination,QDialog,QCard,QCardSection,QCardActions});
